<template>
  <div
    v-if="!isMobile || !$register"

    :key="item.id"
    class="column cursor-pointer col q-pa-sm"
    style="min-width: 200px; max-width: 200px"
    :style="{ opacity: hasReducedOpacity ? 0.3 : 1 }"
  >
    <q-card
      flat
      bordered
      class="full-width full-height position-relative"
      :class="{ [colorClass]: true }"
      @click="$emit('click', item)"
    >
      <div>
        <transition
          leave-class="hidden"
          enter-active-class="animated bounceIn"
        >
          <q-badge
            v-if="itemCount"
            :key="itemCount"
            style="font-size: 18px; z-index: 1"
            class="q-py-sm text-bold"
            :color="hideImage ? 'secondary' : 'primary'"
            :text-color="badgeTextColor"
            floating
          >
            x {{ itemCount }}
          </q-badge>
        </transition>
      </div>
      <q-img
        v-if="!hideImage"
        :src="item.imageUrl"
        :no-spinner="true"
        :no-transition="true"
      />
      <q-card-section class="q-pa-xs">
        <div class="text-center text-bold">
          {{ item.name }}
        </div>
      </q-card-section>
    </q-card>
  </div>
  <div
    v-else
    class="col-sm-4 col-xs-6 full-height q-pr-sm q-pb-sm"
    style="display: flex; flex-direction: column;"
  >
    <q-card
      flat
      bordered
      style="padding: 10px; height: 100%;"
      class="full-width full-height"
      :class="{ [colorClass]: true }"
      @click="$emit('click', item)"
    >
      <div>
        <transition
          leave-class="hidden"
          enter-active-class="animated bounceIn"
        >
          <q-badge
            v-if="itemCount"
            :key="itemCount"
            style="font-size: 18px; z-index: 1"
            class="q-py-sm text-bold"
            :color="hideImage ? 'secondary' : 'primary'"
            :text-color="badgeTextColor"
            floating
          >
            x {{ itemCount }}
          </q-badge>
        </transition>
      </div>
      <q-img
        v-if="!hideImage"
        :src="item.imageUrl"
        :no-spinner="true"
        :no-transition="true"
      />
      <q-card-section class="q-pa-xs">
        <div class="text-center text-bold">
          {{ item.name }}
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
export default {
  name: 'CategoryPageCard',
  props: {
    item: {
      type: Object,
      required: true
    },
    itemCount: {
      type: Number,
      required: true
    },
    hideImage: {
      type: Boolean,
      required: true
    },
    badgeTextColor: {
      type: String,
      required: true
    },
    colorClass: {
      type: String,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    },
    hasReducedOpacity: {
      type: Boolean,
      required: true
    }
  },
  emits: ['click']
}
</script>
